import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight, Search } from 'lucide-react';

// Blog posts data - Original SEO-optimized content
const blogPosts = [
  {
    id: 1,
    slug: 'top-nail-art-trends-bangalore-2026',
    title: 'Top 10 Nail Art Trends in Bangalore 2026',
    excerpt: 'Discover the hottest nail art trends taking over Bangalore salons this year. From chrome finishes to 3D nail art, find your next manicure inspiration.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997391/pexels-photo-3997391.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-04-20',
    readTime: '5 min read',
    content: `
      <p>Nail art has evolved dramatically in recent years, and 2026 is no exception. At BLR Nail Club, we've seen an incredible surge in creative nail designs that blend artistry with personal expression. Here are the top trends dominating Bangalore's nail scene this year.</p>
      
      <h2>1. Chrome and Metallic Finishes</h2>
      <p>The chrome nail trend continues to dominate, with rose gold and silver chrome being the most requested finishes at our RR Nagar and CSK Mall locations. These mirror-like nails catch light beautifully and add instant glamour to any look.</p>
      
      <h2>2. Minimalist French Tips with a Twist</h2>
      <p>The classic French manicure has been reimagined with colored tips, double lines, and geometric patterns. Our clients love the subtle elegance combined with modern flair.</p>
      
      <h2>3. 3D Nail Art</h2>
      <p>Three-dimensional elements like tiny flowers, pearls, and gems are incredibly popular for special occasions. Our skilled technicians at BLR Nail Club create stunning 3D designs that last.</p>
      
      <h2>4. Abstract and Artistic Designs</h2>
      <p>Inspired by modern art, abstract nail designs featuring swirls, color blocks, and artistic patterns are trending among Bangalore's fashion-forward crowd.</p>
      
      <h2>5. Glazed Donut Nails</h2>
      <p>Made famous by celebrities, the glazed donut look creates a subtle, pearlescent finish that's both sophisticated and trendy.</p>
      
      <h2>6. Velvet and Textured Nails</h2>
      <p>Texture is making a comeback with velvet finishes and sugar-coated effects that add dimension to your manicure.</p>
      
      <h2>7. Negative Space Designs</h2>
      <p>Using your natural nail as part of the design creates modern, artistic looks that are both striking and subtle.</p>
      
      <h2>8. Aura Nails</h2>
      <p>Soft, gradient colors that create an ethereal, airbrushed effect are perfect for those who love a dreamy aesthetic.</p>
      
      <h2>9. Gemstone-Inspired Colors</h2>
      <p>Deep emeralds, rich sapphires, and warm ambers inspired by precious stones are making a statement this season.</p>
      
      <h2>10. Customized Nail Charms</h2>
      <p>Personalized charms and tiny accessories that reflect individual personality are the ultimate in nail customization.</p>
      
      <h2>Visit BLR Nail Club Today</h2>
      <p>Ready to try these trends? Book an appointment at any of our locations - RR Nagar, Basaveshwarnagar, or CSK Mall Gunjur. Our expert nail technicians will help you achieve the perfect look for any occasion.</p>
    `
  },
  {
    id: 2,
    slug: 'how-to-make-gel-nails-last-longer',
    title: 'How to Make Your Gel Nails Last Longer: Expert Tips',
    excerpt: 'Learn professional secrets to extend the life of your gel manicure. From prep work to aftercare, discover how to keep your nails flawless for weeks.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997379/pexels-photo-3997379.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-04-18',
    readTime: '6 min read',
    content: `
      <p>Gel nails are beloved for their durability and shine, but how can you make them last even longer? At BLR Nail Club, our technicians share their professional secrets for extending your gel manicure.</p>
      
      <h2>Pre-Application Tips</h2>
      <p><strong>1. Proper Nail Preparation:</strong> Clean, dry nails are essential. Avoid applying lotion to your hands before your appointment as oils can prevent proper adhesion.</p>
      <p><strong>2. Cuticle Care:</strong> Well-maintained cuticles help the gel bond better to your natural nail.</p>
      
      <h2>During Your Appointment</h2>
      <p><strong>3. Thin Layers:</strong> Multiple thin layers cure better and last longer than thick coats.</p>
      <p><strong>4. Cap the Free Edge:</strong> This seals the nail tip and prevents lifting and chipping.</p>
      
      <h2>Aftercare Tips</h2>
      <p><strong>5. Wear Gloves:</strong> Protect your nails when doing dishes or cleaning with harsh chemicals.</p>
      <p><strong>6. Moisturize Daily:</strong> Keep your cuticles and nails hydrated with cuticle oil.</p>
      <p><strong>7. Avoid Hot Water:</strong> Prolonged exposure to hot water can weaken the gel bond.</p>
      <p><strong>8. Don't Pick or Peel:</strong> If you notice lifting, visit BLR Nail Club for a professional fix.</p>
      
      <h2>When to Get a Fill or New Set</h2>
      <p>We recommend getting a fill every 2-3 weeks to maintain the beauty and health of your gel nails. Visit any of our locations for expert care.</p>
    `
  },
  {
    id: 3,
    slug: 'best-nail-shapes-for-your-hands',
    title: 'Best Nail Shapes for Your Hand Type: A Complete Guide',
    excerpt: 'Not sure which nail shape suits you best? Our guide helps you choose the perfect shape based on your finger length, nail bed, and lifestyle.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3993449/pexels-photo-3993449.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-04-15',
    readTime: '7 min read',
    content: `
      <p>Choosing the right nail shape can enhance the appearance of your hands and complement your personal style. At BLR Nail Club, we help clients find their perfect shape every day.</p>
      
      <h2>Oval Nails</h2>
      <p><strong>Best for:</strong> Wide nail beds and short fingers</p>
      <p>Oval nails create an elongating effect, making fingers appear slimmer and longer. This classic shape is elegant and practical.</p>
      
      <h2>Square Nails</h2>
      <p><strong>Best for:</strong> Long, narrow nail beds</p>
      <p>The flat top and sharp corners of square nails create a bold, modern look. Great for those who prefer a strong aesthetic.</p>
      
      <h2>Round Nails</h2>
      <p><strong>Best for:</strong> Short nails and active lifestyles</p>
      <p>Following the natural curve of your fingertip, round nails are low-maintenance and durable.</p>
      
      <h2>Almond Nails</h2>
      <p><strong>Best for:</strong> All hand types</p>
      <p>Slim sides tapering to a rounded peak create a feminine, flattering shape that works for everyone.</p>
      
      <h2>Stiletto Nails</h2>
      <p><strong>Best for:</strong> Long nail beds and special occasions</p>
      <p>Dramatic and eye-catching, stiletto nails make a bold statement.</p>
      
      <h2>Coffin/Ballerina Nails</h2>
      <p><strong>Best for:</strong> Long fingers and those who love trends</p>
      <p>Tapered sides with a flat tip create the popular coffin shape, perfect for nail art.</p>
      
      <h2>Get Expert Advice at BLR Nail Club</h2>
      <p>Not sure which shape is right for you? Our experienced technicians will assess your hands and lifestyle to recommend the perfect shape. Book a consultation today!</p>
    `
  },
  {
    id: 4,
    slug: 'nail-care-tips-indian-climate',
    title: 'Nail Care Tips for Indian Climate: Monsoon to Summer',
    excerpt: 'India\'s diverse climate can be tough on nails. Learn how to protect and maintain beautiful nails through every season with these expert tips.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997386/pexels-photo-3997386.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-04-12',
    readTime: '5 min read',
    content: `
      <p>Bangalore's climate, while pleasant, still presents challenges for nail health. From humid monsoons to dry winters, your nails need different care throughout the year. Here's how to keep them healthy and beautiful.</p>
      
      <h2>Monsoon Nail Care</h2>
      <p><strong>Challenge:</strong> High humidity and frequent water exposure</p>
      <ul>
        <li>Apply waterproof top coat to prevent lifting</li>
        <li>Keep nails shorter to prevent breakage</li>
        <li>Dry hands thoroughly after exposure to rain</li>
        <li>Use antifungal treatments preventatively</li>
      </ul>
      
      <h2>Summer Nail Care</h2>
      <p><strong>Challenge:</strong> Heat and increased sweating</p>
      <ul>
        <li>Choose breathable nail polishes</li>
        <li>Keep nails clean to prevent bacteria buildup</li>
        <li>Use SPF on hands to prevent discoloration</li>
        <li>Stay hydrated for healthy nail growth</li>
      </ul>
      
      <h2>Winter Nail Care</h2>
      <p><strong>Challenge:</strong> Dryness and brittleness</p>
      <ul>
        <li>Apply cuticle oil daily</li>
        <li>Use hand cream regularly</li>
        <li>Avoid harsh soaps</li>
        <li>Consider nail strengthening treatments</li>
      </ul>
      
      <h2>Year-Round Tips</h2>
      <p>Maintain a healthy diet rich in biotin, keep nails at a manageable length, and visit BLR Nail Club regularly for professional care. Our treatments are designed specifically for Indian conditions.</p>
    `
  },
  {
    id: 5,
    slug: 'acrylic-vs-gel-nails-which-is-better',
    title: 'Acrylic vs Gel Nails: Which Is Better for You?',
    excerpt: 'Confused between acrylic and gel nails? We break down the pros and cons of each to help you make the right choice for your lifestyle and preferences.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997387/pexels-photo-3997387.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-04-10',
    readTime: '6 min read',
    content: `
      <p>At BLR Nail Club, one of the most common questions we get is: "Should I get acrylic or gel nails?" Both have their advantages, and the best choice depends on your needs.</p>
      
      <h2>Gel Nails</h2>
      <h3>Pros:</h3>
      <ul>
        <li>More natural, flexible feel</li>
        <li>Glossy, natural-looking finish</li>
        <li>Less damaging to natural nails</li>
        <li>No strong odor during application</li>
        <li>Quicker application process</li>
      </ul>
      <h3>Cons:</h3>
      <ul>
        <li>Less durable than acrylics</li>
        <li>May not provide as much length</li>
        <li>Can be more expensive</li>
      </ul>
      
      <h2>Acrylic Nails</h2>
      <h3>Pros:</h3>
      <ul>
        <li>Very durable and strong</li>
        <li>Great for length and dramatic looks</li>
        <li>Easy to fix if broken</li>
        <li>Generally more affordable</li>
      </ul>
      <h3>Cons:</h3>
      <ul>
        <li>Can look less natural</li>
        <li>Strong odor during application</li>
        <li>Requires more maintenance</li>
      </ul>
      
      <h2>Our Recommendation</h2>
      <p>For everyday wear and a natural look, we recommend gel nails. For special events or if you want dramatic length, acrylics are the way to go. Visit BLR Nail Club for a personalized consultation!</p>
    `
  },
  {
    id: 6,
    slug: 'lash-extensions-complete-guide',
    title: 'Lash Extensions: Everything You Need to Know Before Your First Appointment',
    excerpt: 'Thinking about getting lash extensions? Our comprehensive guide covers types, aftercare, and what to expect during your first session.',
    category: 'Beauty',
    image: 'https://images.pexels.com/photos/3985329/pexels-photo-3985329.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-04-08',
    readTime: '8 min read',
    content: `
      <p>Lash extensions can transform your look, giving you fuller, longer lashes without daily mascara application. At BLR Nail Club, our lash specialists create customized looks for every client.</p>
      
      <h2>Types of Lash Extensions</h2>
      <h3>Classic Lashes</h3>
      <p>One extension per natural lash for a subtle, natural enhancement. Perfect for first-timers.</p>
      
      <h3>Volume Lashes</h3>
      <p>Multiple lightweight extensions per natural lash for a fuller, more dramatic look.</p>
      
      <h3>Hybrid Lashes</h3>
      <p>A mix of classic and volume for the best of both worlds.</p>
      
      <h2>What to Expect During Your Appointment</h2>
      <p>Your first appointment will take 1.5-2 hours. You'll lie comfortably while our technician meticulously applies each extension. It's a relaxing experience - many clients even fall asleep!</p>
      
      <h2>Aftercare Tips</h2>
      <ul>
        <li>Avoid water and steam for 24-48 hours</li>
        <li>Don't use oil-based products near eyes</li>
        <li>Brush lashes daily with a clean spoolie</li>
        <li>Avoid rubbing or pulling at lashes</li>
        <li>Schedule fills every 2-3 weeks</li>
      </ul>
      
      <h2>Book Your Lash Appointment</h2>
      <p>Ready to wake up with perfect lashes every day? Book a lash extension appointment at BLR Nail Club's RR Nagar, Basaveshwarnagar, or CSK Mall location.</p>
    `
  },
  {
    id: 7,
    slug: 'benefits-of-regular-manicure-pedicure',
    title: 'Why Regular Manicures and Pedicures Are Essential for Nail Health',
    excerpt: 'Beyond aesthetics, regular mani-pedis offer real health benefits. Discover why this should be part of your self-care routine.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997393/pexels-photo-3997393.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-04-05',
    readTime: '5 min read',
    content: `
      <p>Many people view manicures and pedicures as luxury treatments, but they're actually important for maintaining nail and skin health. Here's why you should make them a regular part of your routine.</p>
      
      <h2>Health Benefits of Regular Manicures</h2>
      <ul>
        <li><strong>Prevents Infections:</strong> Professional cleaning removes bacteria and fungi</li>
        <li><strong>Improves Blood Circulation:</strong> Massage during the service promotes blood flow</li>
        <li><strong>Maintains Nail Health:</strong> Regular trimming and shaping prevents breakage</li>
        <li><strong>Early Detection:</strong> Technicians can spot potential nail problems early</li>
      </ul>
      
      <h2>Health Benefits of Regular Pedicures</h2>
      <ul>
        <li><strong>Prevents Ingrown Toenails:</strong> Proper trimming techniques prevent painful ingrowns</li>
        <li><strong>Removes Dead Skin:</strong> Exfoliation prevents cracked heels and calluses</li>
        <li><strong>Relieves Stress:</strong> Foot massage reduces tension and promotes relaxation</li>
        <li><strong>Improves Foot Health:</strong> Regular care keeps feet smooth and healthy</li>
      </ul>
      
      <h2>How Often Should You Get Mani-Pedis?</h2>
      <p>We recommend manicures every 1-2 weeks and pedicures every 3-4 weeks. At BLR Nail Club, we use premium products and maintain strict hygiene standards for your safety.</p>
    `
  },
  {
    id: 8,
    slug: 'permanent-makeup-pmu-guide',
    title: 'Permanent Makeup (PMU): What You Need to Know',
    excerpt: 'From microblading to lip tinting, learn about permanent makeup procedures, their benefits, and what to expect at your appointment.',
    category: 'Beauty',
    image: 'https://images.pexels.com/photos/3993293/pexels-photo-3993293.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-04-02',
    readTime: '7 min read',
    content: `
      <p>Permanent makeup, or PMU, has revolutionized the beauty industry by offering long-lasting solutions for brows, lips, and eyeliner. At BLR Nail Club, our certified PMU artists create natural-looking enhancements.</p>
      
      <h2>Popular PMU Services</h2>
      
      <h3>Microblading</h3>
      <p>Creates hair-like strokes for natural-looking eyebrows. Perfect for sparse or over-plucked brows. Lasts 1-2 years.</p>
      
      <h3>Lip Tinting</h3>
      <p>Adds subtle color and definition to lips. Enhances natural lip color and creates the appearance of fuller lips. Lasts 2-3 years.</p>
      
      <h3>Eyeliner Tattoo</h3>
      <p>Defines eyes with permanent eyeliner. Can be subtle or dramatic based on preference. Lasts 3-5 years.</p>
      
      <h2>What to Expect</h2>
      <p><strong>Before:</strong> Consultation to discuss your desired look and skin test for allergies.</p>
      <p><strong>During:</strong> Numbing cream is applied for comfort. The procedure takes 1-2 hours.</p>
      <p><strong>After:</strong> Initial healing takes 7-14 days. A touch-up session is included.</p>
      
      <h2>Aftercare</h2>
      <ul>
        <li>Keep the area dry for 10 days</li>
        <li>Avoid sun exposure</li>
        <li>Don't pick at scabs</li>
        <li>Apply recommended healing ointment</li>
      </ul>
      
      <h2>Book a PMU Consultation</h2>
      <p>Interested in permanent makeup? Book a free consultation at BLR Nail Club to discuss your options.</p>
    `
  },
  {
    id: 9,
    slug: 'nail-art-for-indian-weddings',
    title: 'Stunning Nail Art Ideas for Indian Weddings',
    excerpt: 'Make your bridal look complete with gorgeous nail art. From traditional to contemporary designs, find inspiration for every wedding function.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3993448/pexels-photo-3993448.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-03-28',
    readTime: '6 min read',
    content: `
      <p>Indian weddings call for extraordinary nail art that complements your lehengas and jewelry. At BLR Nail Club, we specialize in bridal nail art that photographs beautifully and lasts through all your celebrations.</p>
      
      <h2>Mehendi/Sangeet Night</h2>
      <p>Go bold with bright colors and intricate designs. Gold glitter, henna-inspired patterns, and jewel tones complement the festive mood perfectly.</p>
      
      <h2>Haldi Ceremony</h2>
      <p>Opt for shorter, sturdy nails in yellow or gold tones that won't interfere with the haldi application.</p>
      
      <h2>Wedding Day</h2>
      <p>Classic reds and maroons with gold accents are timeless choices. Consider adding tiny gems or pearls that match your jewelry.</p>
      
      <h2>Reception</h2>
      <p>Go glamorous with chrome finishes, diamonds, and elaborate 3D designs. This is the time for statement nails!</p>
      
      <h2>Bridal Nail Art Trends</h2>
      <ul>
        <li>Kundan-inspired nail art with stone work</li>
        <li>Matching nails to lehenga embroidery</li>
        <li>Personalized elements like initials or wedding date</li>
        <li>Traditional motifs like paisleys and lotus</li>
      </ul>
      
      <h2>Book Your Bridal Package</h2>
      <p>BLR Nail Club offers special bridal packages covering all wedding functions. Book early to secure your dates!</p>
    `
  },
  {
    id: 10,
    slug: 'healthy-hair-tips-bangalore-weather',
    title: 'Healthy Hair Tips for Bangalore Weather',
    excerpt: 'Bangalore\'s unique climate can affect your hair. Learn how to maintain gorgeous, healthy locks year-round with these expert tips.',
    category: 'Hair',
    image: 'https://images.pexels.com/photos/3993446/pexels-photo-3993446.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-03-25',
    readTime: '5 min read',
    content: `
      <p>Bangalore's moderate climate is generally kind to hair, but the city's hard water and pollution can still cause damage. Here's how to keep your hair healthy and beautiful.</p>
      
      <h2>Dealing with Hard Water</h2>
      <ul>
        <li>Install a shower filter to reduce mineral buildup</li>
        <li>Use clarifying shampoo weekly</li>
        <li>Rinse with diluted apple cider vinegar monthly</li>
        <li>Deep condition regularly to combat dryness</li>
      </ul>
      
      <h2>Pollution Protection</h2>
      <ul>
        <li>Cover hair when commuting</li>
        <li>Wash hair after exposure to heavy pollution</li>
        <li>Use leave-in serums that create protective barriers</li>
        <li>Keep hair tied to minimize surface exposure</li>
      </ul>
      
      <h2>Seasonal Hair Care</h2>
      <p><strong>Summer:</strong> Use UV protection sprays, stay hydrated, and trim regularly.</p>
      <p><strong>Monsoon:</strong> Keep hair dry, use anti-humidity products, and avoid tight hairstyles.</p>
      <p><strong>Winter:</strong> Deep condition weekly, use gentle shampoos, and massage scalp with warm oil.</p>
      
      <h2>Professional Hair Treatments</h2>
      <p>Visit Benefits Salon for professional hair treatments including keratin smoothing, deep conditioning, and scalp treatments customized for Bangalore's conditions.</p>
    `
  },
  {
    id: 11,
    slug: 'skincare-routine-for-indian-skin',
    title: 'The Perfect Skincare Routine for Indian Skin',
    excerpt: 'Indian skin has unique needs. Discover a customized skincare routine that addresses pigmentation, oiliness, and other common concerns.',
    category: 'Skin',
    image: 'https://images.pexels.com/photos/3985330/pexels-photo-3985330.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-03-22',
    readTime: '7 min read',
    content: `
      <p>Indian skin, rich in melanin, has its own set of characteristics and concerns. Here's a skincare routine designed specifically for Indian skin types.</p>
      
      <h2>Morning Routine</h2>
      <ol>
        <li><strong>Gentle Cleanser:</strong> Start with a pH-balanced cleanser</li>
        <li><strong>Toner:</strong> Use alcohol-free toner to balance skin</li>
        <li><strong>Vitamin C Serum:</strong> Brightens and protects against pigmentation</li>
        <li><strong>Moisturizer:</strong> Lightweight for oily skin, richer for dry skin</li>
        <li><strong>Sunscreen:</strong> SPF 50+ is essential - no exceptions!</li>
      </ol>
      
      <h2>Evening Routine</h2>
      <ol>
        <li><strong>Double Cleanse:</strong> Oil cleanser followed by water-based cleanser</li>
        <li><strong>Exfoliate (2-3x weekly):</strong> Use AHAs/BHAs for bright, smooth skin</li>
        <li><strong>Treatment Serum:</strong> Target specific concerns (niacinamide for pores, retinol for aging)</li>
        <li><strong>Moisturizer:</strong> Lock in all the goodness</li>
      </ol>
      
      <h2>Common Concerns for Indian Skin</h2>
      <ul>
        <li><strong>Hyperpigmentation:</strong> Use vitamin C, niacinamide, and consistent sunscreen</li>
        <li><strong>Oiliness:</strong> Don't skip moisturizer; use oil-free formulas</li>
        <li><strong>Dark Circles:</strong> Caffeine serums and adequate sleep help</li>
        <li><strong>Acne Scars:</strong> Consider professional treatments</li>
      </ul>
      
      <h2>Professional Treatments</h2>
      <p>For persistent skin concerns, consult with skincare professionals. BLR Nail Club offers facial treatments that complement your home routine.</p>
    `
  },
  {
    id: 12,
    slug: 'diy-nail-care-between-salon-visits',
    title: 'DIY Nail Care Tips Between Salon Visits',
    excerpt: 'Maintain your beautiful nails at home with these simple yet effective care tips. Keep your manicure looking fresh for longer.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997388/pexels-photo-3997388.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-03-18',
    readTime: '4 min read',
    content: `
      <p>While professional nail care is irreplaceable, there's plenty you can do at home to maintain healthy, beautiful nails between your BLR Nail Club appointments.</p>
      
      <h2>Daily Nail Care Habits</h2>
      <ul>
        <li>Apply cuticle oil every night before bed</li>
        <li>Keep nails dry and clean to prevent bacteria</li>
        <li>Wear gloves when doing household chores</li>
        <li>Moisturize hands after every wash</li>
      </ul>
      
      <h2>Weekly Maintenance</h2>
      <ul>
        <li>Gently push back cuticles after showering (never cut!)</li>
        <li>File nails in one direction to prevent splitting</li>
        <li>Apply a strengthening base coat</li>
        <li>Give nails a break from polish occasionally</li>
      </ul>
      
      <h2>Emergency Fixes</h2>
      <p><strong>Chipped Polish:</strong> Apply a glitter top coat to disguise chips temporarily.</p>
      <p><strong>Broken Nail:</strong> Use a tea bag patch as a temporary fix until your salon visit.</p>
      <p><strong>Lifted Gel:</strong> Apply nail glue carefully and book an appointment ASAP.</p>
      
      <h2>What to Avoid</h2>
      <ul>
        <li>Using nails as tools</li>
        <li>Peeling off gel polish</li>
        <li>Cutting cuticles at home</li>
        <li>Using acetone-based removers frequently</li>
      </ul>
    `
  },
  {
    id: 13,
    slug: 'choosing-right-nail-polish-color',
    title: 'How to Choose the Right Nail Polish Color for Your Skin Tone',
    excerpt: 'Finding the perfect nail color can be tricky. Our guide helps you pick shades that complement your Indian skin tone beautifully.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997390/pexels-photo-3997390.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-03-15',
    readTime: '5 min read',
    content: `
      <p>The right nail polish color can make your hands look elegant and your skin glow. Here's how to find your perfect shades based on Indian skin tones.</p>
      
      <h2>Fair Indian Skin Tones</h2>
      <p><strong>Best Colors:</strong></p>
      <ul>
        <li>Soft pinks and peaches</li>
        <li>Berry shades</li>
        <li>Light corals</li>
        <li>Nude with pink undertones</li>
      </ul>
      <p><strong>Avoid:</strong> Very pale colors that wash you out</p>
      
      <h2>Medium/Wheatish Skin Tones</h2>
      <p><strong>Best Colors:</strong></p>
      <ul>
        <li>Warm nudes and browns</li>
        <li>Deep roses and mauves</li>
        <li>Burnt orange and terracotta</li>
        <li>Classic reds</li>
      </ul>
      <p><strong>Avoid:</strong> Neons and very bright colors</p>
      
      <h2>Dusky/Dark Skin Tones</h2>
      <p><strong>Best Colors:</strong></p>
      <ul>
        <li>Bold, vibrant shades</li>
        <li>Deep burgundies and plums</li>
        <li>Bright corals and oranges</li>
        <li>Metallics and golds</li>
      </ul>
      <p><strong>Avoid:</strong> Very light pastels</p>
      
      <h2>Universal Colors That Work for Everyone</h2>
      <ul>
        <li>Classic red (blue-based reds are most flattering)</li>
        <li>Nude pink</li>
        <li>Deep wine</li>
        <li>Shimmery rose gold</li>
      </ul>
      
      <h2>Get Personalized Recommendations</h2>
      <p>Still unsure? Visit BLR Nail Club where our experts will help you find your perfect shades!</p>
    `
  },
  {
    id: 14,
    slug: 'self-care-sunday-routine',
    title: 'The Ultimate Self-Care Sunday Routine',
    excerpt: 'Dedicate one day a week to yourself. Here\'s a complete self-care routine covering nails, skin, hair, and relaxation.',
    category: 'Beauty',
    image: 'https://images.pexels.com/photos/3997394/pexels-photo-3997394.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-03-10',
    readTime: '6 min read',
    content: `
      <p>In our busy lives, it's essential to carve out time for self-care. Here's a complete Sunday routine to rejuvenate your body and mind.</p>
      
      <h2>Morning: Start Fresh</h2>
      <ul>
        <li>Wake up without an alarm</li>
        <li>Drink warm lemon water</li>
        <li>Do gentle stretching or yoga</li>
        <li>Enjoy a healthy, leisurely breakfast</li>
      </ul>
      
      <h2>Late Morning: Hair Care</h2>
      <ul>
        <li>Apply warm coconut oil to scalp and hair</li>
        <li>Leave for 30-60 minutes</li>
        <li>Wash with gentle shampoo</li>
        <li>Apply deep conditioning mask</li>
      </ul>
      
      <h2>Afternoon: Skin Care</h2>
      <ul>
        <li>Steam face for 5-10 minutes</li>
        <li>Apply exfoliating mask</li>
        <li>Use eye patches while relaxing</li>
        <li>Apply hydrating face mask</li>
        <li>Finish with facial massage</li>
      </ul>
      
      <h2>Late Afternoon: Nail Care</h2>
      <ul>
        <li>Remove old polish properly</li>
        <li>Soak hands and feet in warm water</li>
        <li>Trim and shape nails</li>
        <li>Push back cuticles gently</li>
        <li>Apply cuticle oil and hand cream</li>
      </ul>
      
      <h2>Evening: Relaxation</h2>
      <ul>
        <li>Take a long, warm bath with bath salts</li>
        <li>Apply body moisturizer</li>
        <li>Do a gentle nighttime skincare routine</li>
        <li>Read a book or meditate</li>
        <li>Get to bed early</li>
      </ul>
      
      <h2>Better Yet: Visit BLR Nail Club!</h2>
      <p>Let professionals pamper you! Book a Sunday appointment for a complete mani-pedi experience and truly relax.</p>
    `
  },
  {
    id: 15,
    slug: 'nail-salon-hygiene-what-to-look-for',
    title: 'Nail Salon Hygiene: What to Look For',
    excerpt: 'Your health matters! Learn what hygiene standards a quality nail salon should maintain and what red flags to watch out for.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997385/pexels-photo-3997385.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-03-05',
    readTime: '5 min read',
    content: `
      <p>When choosing a nail salon, hygiene should be your top priority. Poor sanitation can lead to infections, fungal problems, and more. Here's what to look for.</p>
      
      <h2>Signs of a Hygienic Salon</h2>
      <ul>
        <li><strong>Licensed Technicians:</strong> Certificates should be displayed</li>
        <li><strong>Clean Workspace:</strong> Tables wiped between clients</li>
        <li><strong>Sterilized Tools:</strong> Metal tools should be autoclaved</li>
        <li><strong>Disposable Items:</strong> Files, buffers, and toe separators should be new</li>
        <li><strong>Clean Foot Baths:</strong> Should be disinfected between clients</li>
        <li><strong>Fresh Towels:</strong> Clean, laundered towels for each client</li>
      </ul>
      
      <h2>Red Flags to Watch Out For</h2>
      <ul>
        <li>Strong chemical smell (indicates poor ventilation)</li>
        <li>Dusty or dirty surfaces</li>
        <li>Tools taken from drawers without visible sterilization</li>
        <li>Reused files or buffers</li>
        <li>Technicians not washing hands between clients</li>
        <li>Cloudy water in foot baths</li>
      </ul>
      
      <h2>Questions to Ask</h2>
      <ul>
        <li>How do you sterilize your tools?</li>
        <li>Are nail files and buffers single-use?</li>
        <li>How often are foot baths cleaned?</li>
        <li>What products do you use?</li>
      </ul>
      
      <h2>BLR Nail Club's Hygiene Standards</h2>
      <p>At BLR Nail Club, we maintain the highest hygiene standards:</p>
      <ul>
        <li>Hospital-grade sterilization of all tools</li>
        <li>Single-use files, buffers, and disposables</li>
        <li>Premium, safe products from trusted brands</li>
        <li>Regular deep cleaning of all equipment</li>
        <li>Trained, certified technicians</li>
      </ul>
      <p>Your safety is our priority. Book with confidence at any of our locations!</p>
    `
  },
  // NEW SEO BLOGS - Location-Specific
  {
    id: 16,
    slug: 'best-nail-salon-rr-nagar-bangalore',
    title: 'Best Nail Salon in RR Nagar: Why BLR Nail Club Stands Out',
    excerpt: 'Looking for the best nail salon in RR Nagar, Bangalore? Discover why BLR Nail Club is the top choice for nail extensions, gel nails, and nail art in Rajarajeshwari Nagar.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997390/pexels-photo-3997390.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-06-15',
    readTime: '5 min read',
    content: `
      <p>When it comes to finding the <strong>best nail salon in RR Nagar</strong>, BLR Nail Club has established itself as the go-to destination for nail enthusiasts in Rajarajeshwari Nagar and surrounding areas. Here's what makes us the top choice.</p>
      
      <h2>Why Choose BLR Nail Club RR Nagar?</h2>
      <p>Located at N2VK Arcade on Jawaharlal Nehru Road, our RR Nagar salon offers:</p>
      <ul>
        <li>Certified nail technicians with 5+ years experience</li>
        <li>Premium products from OPI, Gelish, and CND</li>
        <li>Hospital-grade sterilization</li>
        <li>Trendy nail art designs updated monthly</li>
        <li>Affordable pricing with no hidden charges</li>
      </ul>
      
      <h2>Popular Services at Our RR Nagar Location</h2>
      <p>Our most requested services include:</p>
      <ul>
        <li><strong>Gel Nail Extensions</strong> - Starting ₹1,499</li>
        <li><strong>Classic Manicure</strong> - Starting ₹499</li>
        <li><strong>Spa Pedicure</strong> - Starting ₹799</li>
        <li><strong>Nail Art</strong> - Starting ₹100 per nail</li>
        <li><strong>Acrylic Extensions</strong> - Starting ₹1,999</li>
      </ul>
      
      <h2>Serving RR Nagar & Nearby Areas</h2>
      <p>We proudly serve customers from Kengeri, Nagarbhavi, Vijayanagar, Mysore Road, and BEML Layout. Our convenient location makes us easily accessible for all your nail care needs.</p>
      
      <h2>Book Your Appointment Today</h2>
      <p>Visit the best nail salon in RR Nagar and experience the BLR Nail Club difference. Call us at +91 7204602211 or book online!</p>
    `
  },
  {
    id: 17,
    slug: 'nail-salon-basaveshwarnagar-top-picks',
    title: 'Top Nail Salon in Basaveshwarnagar: Complete Guide 2026',
    excerpt: 'Searching for nail salon in Basaveshwarnagar? Our complete guide covers the best nail services, prices, and why BLR Nail Club is the preferred choice in West Bangalore.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997391/pexels-photo-3997391.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-06-14',
    readTime: '6 min read',
    content: `
      <p>Basaveshwarnagar residents no longer need to travel far for premium nail services. <strong>BLR Nail Club Basaveshwarnagar</strong> brings world-class nail artistry right to your neighborhood.</p>
      
      <h2>What Sets Us Apart in Basaveshwarnagar</h2>
      <p>Our West of Chord Road location offers:</p>
      <ul>
        <li>Award-winning nail artists</li>
        <li>Latest nail art trends from Instagram & Pinterest</li>
        <li>Premium imported nail products</li>
        <li>Comfortable AC studio with free WiFi</li>
        <li>Easy parking available</li>
      </ul>
      
      <h2>Trending Nail Designs in Basaveshwarnagar</h2>
      <p>Our clients love:</p>
      <ul>
        <li><strong>3D Nail Art</strong> - Perfect for special occasions</li>
        <li><strong>Chrome Nails</strong> - The mirror finish everyone's talking about</li>
        <li><strong>Polygel Extensions</strong> - Lighter and more flexible</li>
        <li><strong>French Ombre</strong> - Classic meets modern</li>
      </ul>
      
      <h2>Areas We Serve</h2>
      <p>Conveniently located for customers from Rajajinagar, Vijayanagar, Mahalakshmi Layout, Kamakshipalya, and Nandini Layout.</p>
      
      <h2>Visit Us Today</h2>
      <p>Experience the best nail salon in Basaveshwarnagar. Walk-ins welcome, appointments preferred. Call +91 7204602211.</p>
    `
  },
  {
    id: 18,
    slug: 'nail-extensions-bangalore-complete-guide',
    title: 'Nail Extensions in Bangalore: Types, Prices & Best Salons 2026',
    excerpt: 'Complete guide to nail extensions in Bangalore. Learn about gel, acrylic, polygel extensions, prices, and find the best nail extension services near you.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997384/pexels-photo-3997384.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-06-12',
    readTime: '8 min read',
    content: `
      <p>Nail extensions have become one of the most popular beauty treatments in Bangalore. Whether you want length, strength, or stunning nail art, extensions are the perfect solution. Here's everything you need to know about <strong>nail extensions in Bangalore</strong>.</p>
      
      <h2>Types of Nail Extensions Available</h2>
      
      <h3>1. Gel Nail Extensions</h3>
      <p>Most popular choice in Bangalore. Lightweight, natural-looking, and flexible. Perfect for everyday wear.</p>
      <p><strong>Price at BLR Nail Club:</strong> ₹1,499 onwards</p>
      
      <h3>2. Acrylic Nail Extensions</h3>
      <p>Strongest and most durable option. Ideal for those who are hard on their nails.</p>
      <p><strong>Price at BLR Nail Club:</strong> ₹1,999 onwards</p>
      
      <h3>3. Polygel Extensions</h3>
      <p>Combines benefits of both gel and acrylic. Lighter than acrylic, stronger than gel.</p>
      <p><strong>Price at BLR Nail Club:</strong> ₹1,799 onwards</p>
      
      <h3>4. Fiberglass Extensions</h3>
      <p>Natural-looking and thin. Best for nail repair and subtle length.</p>
      <p><strong>Price at BLR Nail Club:</strong> ₹1,599 onwards</p>
      
      <h2>Where to Get Nail Extensions in Bangalore</h2>
      <p>BLR Nail Club offers nail extensions at 3 convenient locations:</p>
      <ul>
        <li><strong>RR Nagar</strong> - N2VK Arcade, Jawaharlal Nehru Road</li>
        <li><strong>Basaveshwarnagar</strong> - West of Chord Road</li>
        <li><strong>Varthur/Sarjapur</strong> - CSK Mall, Gunjur</li>
      </ul>
      
      <h2>How to Maintain Nail Extensions</h2>
      <ul>
        <li>Get fills every 2-3 weeks</li>
        <li>Avoid using nails as tools</li>
        <li>Wear gloves when cleaning</li>
        <li>Keep cuticles moisturized</li>
      </ul>
      
      <h2>Book Your Nail Extension Appointment</h2>
      <p>Ready for beautiful, long nails? Book at BLR Nail Club today!</p>
    `
  },
  {
    id: 19,
    slug: 'manicure-pedicure-bangalore-prices-guide',
    title: 'Manicure & Pedicure in Bangalore: Prices, Types & Best Salons',
    excerpt: 'Everything about manicure and pedicure services in Bangalore. Compare prices, types of treatments, and find the best salons for mani-pedi near you.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997385/pexels-photo-3997385.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-06-10',
    readTime: '7 min read',
    content: `
      <p>A good <strong>manicure and pedicure in Bangalore</strong> is essential for well-groomed hands and feet. Whether you prefer a quick express service or a luxurious spa treatment, here's your complete guide.</p>
      
      <h2>Types of Manicure Services</h2>
      
      <h3>Classic Manicure - ₹499</h3>
      <p>Includes nail shaping, cuticle care, hand massage, and polish application.</p>
      
      <h3>Gel Manicure - ₹799</h3>
      <p>Long-lasting gel polish that stays chip-free for 2-3 weeks.</p>
      
      <h3>Spa Manicure - ₹999</h3>
      <p>Luxurious treatment with exfoliation, mask, extended massage, and polish.</p>
      
      <h3>Express Manicure - ₹399</h3>
      <p>Quick 30-minute service for busy professionals.</p>
      
      <h2>Types of Pedicure Services</h2>
      
      <h3>Classic Pedicure - ₹599</h3>
      <p>Foot soak, scrub, nail care, and polish.</p>
      
      <h3>Spa Pedicure - ₹799</h3>
      <p>Extended treatment with callus removal, mask, and massage.</p>
      
      <h3>Luxury Pedicure - ₹999</h3>
      <p>Premium service with paraffin wax treatment and aromatherapy.</p>
      
      <h2>Mani-Pedi Combo Deals</h2>
      <p>At BLR Nail Club, save with our combo packages:</p>
      <ul>
        <li><strong>Classic Mani + Pedi:</strong> ₹999 (Save ₹99)</li>
        <li><strong>Spa Mani + Pedi:</strong> ₹1,599 (Save ₹199)</li>
        <li><strong>Luxury Mani + Pedi:</strong> ₹1,799 (Save ₹199)</li>
      </ul>
      
      <h2>Best Places for Manicure Pedicure in Bangalore</h2>
      <p>Visit BLR Nail Club at RR Nagar, Basaveshwarnagar, or Varthur for the best mani-pedi experience in Bangalore!</p>
    `
  },
  {
    id: 20,
    slug: 'gel-nails-near-me-bangalore-guide',
    title: 'Gel Nails Near Me in Bangalore: Find the Best Gel Nail Salons',
    excerpt: 'Searching for gel nails near you in Bangalore? Learn about gel nail services, prices, and find the best salons for gel manicure in your area.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997386/pexels-photo-3997386.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-06-08',
    readTime: '6 min read',
    content: `
      <p>If you're searching for <strong>"gel nails near me"</strong> in Bangalore, you're in the right place. Gel nails offer the perfect combination of durability and beauty. Here's everything you need to know.</p>
      
      <h2>What Are Gel Nails?</h2>
      <p>Gel nails are a type of nail enhancement that uses a gel-based polish cured under UV or LED light. They offer:</p>
      <ul>
        <li>High shine finish</li>
        <li>2-3 weeks of chip-free wear</li>
        <li>Natural-looking results</li>
        <li>Quick drying time</li>
      </ul>
      
      <h2>Gel Nail Services & Prices in Bangalore</h2>
      <ul>
        <li><strong>Gel Polish (Natural Nails):</strong> ₹599</li>
        <li><strong>Gel Extensions (Tips):</strong> ₹1,499</li>
        <li><strong>Builder Gel Overlay:</strong> ₹899</li>
        <li><strong>Gel Nail Art:</strong> ₹100+ per nail</li>
        <li><strong>Gel Removal:</strong> ₹299</li>
      </ul>
      
      <h2>Where to Get Gel Nails in Bangalore</h2>
      <p><strong>BLR Nail Club Locations:</strong></p>
      <ul>
        <li><strong>RR Nagar:</strong> Best for Rajarajeshwari Nagar, Kengeri, Nagarbhavi</li>
        <li><strong>Basaveshwarnagar:</strong> Best for West Bangalore, Rajajinagar, Vijayanagar</li>
        <li><strong>Varthur/Gunjur:</strong> Best for Sarjapur Road, Whitefield, Bellandur</li>
      </ul>
      
      <h2>How Long Do Gel Nails Last?</h2>
      <p>With proper care, gel nails last 2-3 weeks before needing a fill or removal. Tips for longevity:</p>
      <ul>
        <li>Wear gloves when cleaning</li>
        <li>Apply cuticle oil daily</li>
        <li>Avoid hot water soaking</li>
        <li>Don't peel or pick at the gel</li>
      </ul>
      
      <h2>Book Your Gel Nail Appointment</h2>
      <p>Find gel nails near you at BLR Nail Club. Book online or call +91 7204602211!</p>
    `
  },
  {
    id: 21,
    slug: 'hair-salon-rr-nagar-bangalore',
    title: 'Best Hair Salon in RR Nagar, Bangalore: Services & Prices 2026',
    excerpt: 'Looking for the best hair salon in RR Nagar? Discover top hair services including haircuts, coloring, treatments, smoothening, and more at competitive prices.',
    category: 'Hair',
    image: 'https://images.pexels.com/photos/3993449/pexels-photo-3993449.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-06-06',
    readTime: '7 min read',
    content: `
      <p>Finding the right <strong>hair salon in RR Nagar</strong> can transform your look. BLR Nail Club offers comprehensive hair services alongside our renowned nail treatments.</p>
      
      <h2>Hair Services at BLR Nail Club RR Nagar</h2>
      
      <h3>Haircuts & Styling</h3>
      <ul>
        <li>Women's Haircut & Styling - ₹499 onwards</li>
        <li>Men's Haircut - ₹299 onwards</li>
        <li>Kids Haircut - ₹199 onwards</li>
        <li>Blow Dry & Styling - ₹399 onwards</li>
      </ul>
      
      <h3>Hair Coloring</h3>
      <ul>
        <li>Global Color - ₹1,999 onwards</li>
        <li>Highlights/Lowlights - ₹2,499 onwards</li>
        <li>Balayage - ₹3,999 onwards</li>
        <li>Root Touch-up - ₹999 onwards</li>
      </ul>
      
      <h3>Hair Treatments</h3>
      <ul>
        <li>Keratin Treatment - ₹4,999 onwards</li>
        <li>Hair Spa - ₹999 onwards</li>
        <li>Hair Botox - ₹3,999 onwards</li>
        <li>Olaplex Treatment - ₹2,499 onwards</li>
      </ul>
      
      <h3>Hair Smoothening</h3>
      <ul>
        <li>Permanent Straightening - ₹3,999 onwards</li>
        <li>Smoothening - ₹2,999 onwards</li>
        <li>Rebonding - ₹4,499 onwards</li>
      </ul>
      
      <h2>Why Choose BLR Nail Club for Hair Services?</h2>
      <ul>
        <li>Experienced stylists trained in latest techniques</li>
        <li>Premium products (L'Oreal, Schwarzkopf, Matrix)</li>
        <li>Personalized consultation</li>
        <li>Clean, comfortable environment</li>
      </ul>
      
      <h2>Book Your Hair Appointment</h2>
      <p>Visit our RR Nagar salon for the best hair services in Rajarajeshwari Nagar!</p>
    `
  },
  {
    id: 22,
    slug: 'nail-art-designs-trending-bangalore',
    title: '25 Trending Nail Art Designs in Bangalore 2026',
    excerpt: 'Get inspired by the hottest nail art designs trending in Bangalore. From minimalist to bold, find your perfect nail art style at the best nail salons.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997379/pexels-photo-3997379.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-06-04',
    readTime: '9 min read',
    content: `
      <p>Bangalore's nail art scene is thriving with creative designs. Here are the <strong>25 most trending nail art designs</strong> that our clients love at BLR Nail Club.</p>
      
      <h2>Minimalist Designs</h2>
      <ol>
        <li><strong>Single Line Art</strong> - Simple, elegant lines</li>
        <li><strong>Dot Art</strong> - Polka dots in trendy arrangements</li>
        <li><strong>Negative Space</strong> - Using natural nail as design element</li>
        <li><strong>Micro French</strong> - Thin, delicate french tips</li>
        <li><strong>Half Moon</strong> - Reverse french at the cuticle</li>
      </ol>
      
      <h2>Bold & Statement Designs</h2>
      <ol start="6">
        <li><strong>Chrome Nails</strong> - Mirror-finish metallics</li>
        <li><strong>3D Flowers</strong> - Sculpted floral designs</li>
        <li><strong>Encapsulated Art</strong> - Designs embedded in gel</li>
        <li><strong>Graffiti Nails</strong> - Street art inspired</li>
        <li><strong>Marble Effect</strong> - Stone-inspired patterns</li>
      </ol>
      
      <h2>Trendy Patterns</h2>
      <ol start="11">
        <li><strong>Abstract Swirls</strong> - Fluid, artistic patterns</li>
        <li><strong>Geometric Shapes</strong> - Bold lines and angles</li>
        <li><strong>Animal Print</strong> - Leopard, zebra, cow print</li>
        <li><strong>Floral Gardens</strong> - Detailed flower arrangements</li>
        <li><strong>Gradient Ombre</strong> - Smooth color transitions</li>
      </ol>
      
      <h2>Special Effects</h2>
      <ol start="16">
        <li><strong>Glazed Donut</strong> - Pearlescent shimmer</li>
        <li><strong>Velvet Nails</strong> - Textured, fuzzy finish</li>
        <li><strong>Cat Eye</strong> - Magnetic polish effect</li>
        <li><strong>Aurora Nails</strong> - Northern lights inspired</li>
        <li><strong>Jelly Nails</strong> - Translucent, glossy look</li>
      </ol>
      
      <h2>Indian-Inspired</h2>
      <ol start="21">
        <li><strong>Henna Patterns</strong> - Traditional mehendi designs</li>
        <li><strong>Temple Jewelry</strong> - Gold embellishments</li>
        <li><strong>Saree Border</strong> - Inspired by traditional textiles</li>
        <li><strong>Paisley Art</strong> - Classic Indian motifs</li>
        <li><strong>Festival Specials</strong> - Diwali, Holi themes</li>
      </ol>
      
      <h2>Get Your Nail Art at BLR Nail Club</h2>
      <p>Starting at just ₹100 per nail, bring any design to our skilled artists. Visit our RR Nagar, Basaveshwarnagar, or Varthur location!</p>
    `
  },
  {
    id: 23,
    slug: 'nail-salon-varthur-sarjapur-road',
    title: 'Nail Salon in Varthur & Sarjapur Road: Your Beauty Guide',
    excerpt: 'Discover the best nail salon in Varthur and Sarjapur Road area. BLR Nail Club at CSK Mall offers premium nail services for East Bangalore residents.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997390/pexels-photo-3997390.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-06-02',
    readTime: '5 min read',
    content: `
      <p>East Bangalore finally has a premium <strong>nail salon in Varthur and Sarjapur Road</strong>! BLR Nail Club at CSK Mall Gunjur brings expert nail services to the IT corridor.</p>
      
      <h2>Why We're Perfect for Sarjapur Road</h2>
      <ul>
        <li>Extended hours till 9 PM - perfect for IT professionals</li>
        <li>Located in CSK Mall with ample parking</li>
        <li>Quick lunch-break services available</li>
        <li>Walk-in friendly</li>
      </ul>
      
      <h2>Services at Our Varthur Location</h2>
      <ul>
        <li>Gel Nail Extensions - ₹1,499</li>
        <li>Express Manicure - ₹399</li>
        <li>Luxury Pedicure - ₹999</li>
        <li>Ombre Nails - ₹1,599</li>
        <li>Lash Extensions - ₹2,499</li>
      </ul>
      
      <h2>Areas We Serve</h2>
      <p>Conveniently located for:</p>
      <ul>
        <li>Varthur</li>
        <li>Sarjapur Road</li>
        <li>Whitefield</li>
        <li>Marathahalli</li>
        <li>Bellandur</li>
        <li>Gunjur</li>
        <li>Carmelaram</li>
      </ul>
      
      <h2>Corporate Partnerships</h2>
      <p>We offer special corporate tie-ups for tech companies on Sarjapur Road. Contact us for group booking discounts!</p>
      
      <h2>Visit CSK Mall Gunjur</h2>
      <p>Book your appointment at the best nail salon on Sarjapur Road. Call +91 7204602211!</p>
    `
  },
  {
    id: 24,
    slug: 'bridal-nail-art-bangalore-wedding',
    title: 'Bridal Nail Art in Bangalore: Complete Wedding Nails Guide',
    excerpt: 'Planning your wedding? Get the perfect bridal nail art in Bangalore. From engagement to reception, complete guide to wedding nails, packages, and prices.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3993449/pexels-photo-3993449.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-05-30',
    readTime: '8 min read',
    content: `
      <p>Your wedding day demands perfect nails. At BLR Nail Club, we specialize in <strong>bridal nail art in Bangalore</strong> that complements your outfit and enhances your beauty.</p>
      
      <h2>Bridal Nail Packages</h2>
      
      <h3>Engagement Package - ₹2,999</h3>
      <ul>
        <li>Gel extensions</li>
        <li>Simple nail art</li>
        <li>Gel polish</li>
        <li>Spa manicure</li>
      </ul>
      
      <h3>Sangeet Package - ₹3,499</h3>
      <ul>
        <li>Gel extensions</li>
        <li>Glitter/shimmer design</li>
        <li>Nail charms</li>
        <li>Spa mani-pedi</li>
      </ul>
      
      <h3>Bridal Package - ₹4,999</h3>
      <ul>
        <li>Premium gel extensions</li>
        <li>Custom bridal nail art</li>
        <li>Crystal/stone embellishments</li>
        <li>Luxury mani-pedi</li>
        <li>Touch-up kit</li>
      </ul>
      
      <h3>Complete Wedding Package - ₹9,999</h3>
      <ul>
        <li>Engagement + Mehendi + Sangeet + Wedding day nails</li>
        <li>Includes family discount (2 members)</li>
        <li>Complimentary touch-ups</li>
      </ul>
      
      <h2>Popular Bridal Nail Designs</h2>
      <ul>
        <li><strong>Red & Gold</strong> - Classic South Indian bridal</li>
        <li><strong>Pastel French</strong> - Subtle and elegant</li>
        <li><strong>Stone Studded</strong> - Glamorous and bold</li>
        <li><strong>Matching Lehenga</strong> - Custom color matching</li>
        <li><strong>Minimalist Shine</strong> - Chrome or glazed finish</li>
      </ul>
      
      <h2>Bride Tribe Packages</h2>
      <p>Book for bridesmaids and get group discounts! Perfect for your pre-wedding party.</p>
      
      <h2>Book Your Bridal Consultation</h2>
      <p>Schedule a consultation at any BLR Nail Club location. Let's plan your perfect wedding nails!</p>
    `
  },
  {
    id: 25,
    slug: 'lash-extensions-bangalore-complete-guide',
    title: 'Lash Extensions in Bangalore: Types, Prices & Best Salons 2026',
    excerpt: 'Everything about lash extensions in Bangalore. Classic, volume, hybrid lashes - learn about types, prices, aftercare, and find the best lash salon near you.',
    category: 'Beauty',
    image: 'https://images.pexels.com/photos/3997391/pexels-photo-3997391.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-05-28',
    readTime: '7 min read',
    content: `
      <p><strong>Lash extensions in Bangalore</strong> have become a beauty essential. Wake up with perfect lashes every day! Here's your complete guide.</p>
      
      <h2>Types of Lash Extensions</h2>
      
      <h3>Classic Lashes - ₹2,499</h3>
      <p>One extension per natural lash. Natural, everyday look.</p>
      
      <h3>Volume Lashes - ₹3,499</h3>
      <p>Multiple fine extensions per lash. Fuller, dramatic effect.</p>
      
      <h3>Hybrid Lashes - ₹2,999</h3>
      <p>Mix of classic and volume. Best of both worlds.</p>
      
      <h3>Mega Volume - ₹4,499</h3>
      <p>Maximum fullness. Perfect for special occasions.</p>
      
      <h2>Lash Extension Styles</h2>
      <ul>
        <li><strong>Natural</strong> - Subtle enhancement</li>
        <li><strong>Cat Eye</strong> - Longer at outer corners</li>
        <li><strong>Doll Eye</strong> - Longer in the center</li>
        <li><strong>Wispy</strong> - Textured, feathery look</li>
      </ul>
      
      <h2>How Long Do They Last?</h2>
      <p>Lash extensions last 4-6 weeks with proper care. We recommend fills every 2-3 weeks.</p>
      
      <h2>Aftercare Tips</h2>
      <ul>
        <li>Avoid water for 24 hours</li>
        <li>Don't use oil-based products</li>
        <li>Brush daily with a spoolie</li>
        <li>Sleep on your back</li>
        <li>Avoid rubbing eyes</li>
      </ul>
      
      <h2>Where to Get Lash Extensions in Bangalore</h2>
      <p>BLR Nail Club offers professional lash extensions at RR Nagar, Basaveshwarnagar, and Varthur. Book your appointment today!</p>
    `
  },
  {
    id: 26,
    slug: 'nail-salon-sahakarnagar-north-bangalore',
    title: 'Best Nail Salon in Sahakarnagar: Now Open in North Bangalore!',
    excerpt: 'BLR Nail Club is now open in Sahakarnagar! Visit our new North Bangalore location on Sahakarnagar Main Road for premium nail extensions, gel nails, and nail art.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997384/pexels-photo-3997384.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-07-15',
    readTime: '5 min read',
    content: `
      <p>Great news for <strong>Sahakarnagar</strong> residents! BLR Nail Club is now open in North Bangalore! Visit our brand new studio on Sahakarnagar Main Road.</p>
      
      <h2>Now Open in Sahakarnagar!</h2>
      <p><strong>Address:</strong> Ground Floor, 332, Sahakarnagar Main Rd, next to Bounce, Park View Layout, Byatarayanapura, Bengaluru 560092</p>
      <p><strong>Phone:</strong> +91 7204604503</p>
      <p><strong>Timings:</strong> 10 AM - 8 PM (All days)</p>
      
      <h2>Areas We Serve</h2>
      <p>Our Sahakarnagar location serves:</p>
      <ul>
        <li>Sahakarnagar</li>
        <li>Hebbal</li>
        <li>Yelahanka</li>
        <li>RT Nagar</li>
        <li>Kodigehalli</li>
        <li>Jakkur</li>
        <li>Byatarayanapura</li>
        <li>Park View Layout</li>
      </ul>
      
      <h2>Services Available</h2>
      <ul>
        <li><strong>Gel Nail Extensions</strong> - ₹1,499 onwards</li>
        <li><strong>Classic Manicure</strong> - ₹499 onwards</li>
        <li><strong>Spa Pedicure</strong> - ₹799 onwards</li>
        <li><strong>Nail Art</strong> - ₹100 per nail</li>
        <li><strong>Acrylic Extensions</strong> - ₹1,999 onwards</li>
      </ul>
      
      <h2>Why Choose Our Sahakarnagar Location?</h2>
      <ul>
        <li>Convenient location on Sahakarnagar Main Road</li>
        <li>Expert nail technicians</li>
        <li>Premium products (OPI, Gelish, CND)</li>
        <li>Easy parking available</li>
        <li>Hygienic practices with sterilized tools</li>
      </ul>
      
      <h2>Book Your Appointment</h2>
      <p>Call +91 7204604503 or visit us at our Sahakarnagar studio. Walk-ins welcome!</p>
    `
  },
  {
    id: 27,
    slug: 'acrylic-nails-bangalore-everything-know',
    title: 'Acrylic Nails in Bangalore: Everything You Need to Know',
    excerpt: 'Complete guide to acrylic nails in Bangalore. Pros, cons, prices, maintenance, and the best salons for acrylic nail extensions near you.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997385/pexels-photo-3997385.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-05-22',
    readTime: '8 min read',
    content: `
      <p><strong>Acrylic nails</strong> are the strongest and most durable nail enhancement option. If you're considering acrylics in Bangalore, here's everything you need to know.</p>
      
      <h2>What Are Acrylic Nails?</h2>
      <p>Acrylic nails are created by combining a liquid monomer with a powder polymer. This mixture hardens when exposed to air, creating a strong, durable nail extension.</p>
      
      <h2>Acrylic vs Gel Nails</h2>
      <table>
        <tr><th>Feature</th><th>Acrylic</th><th>Gel</th></tr>
        <tr><td>Durability</td><td>Very Strong</td><td>Strong</td></tr>
        <tr><td>Weight</td><td>Heavier</td><td>Lighter</td></tr>
        <tr><td>Flexibility</td><td>Rigid</td><td>Flexible</td></tr>
        <tr><td>Removal</td><td>Acetone soak</td><td>Acetone soak</td></tr>
        <tr><td>Price</td><td>₹1,999+</td><td>₹1,499+</td></tr>
      </table>
      
      <h2>Acrylic Nail Prices at BLR Nail Club</h2>
      <ul>
        <li><strong>Full Set (New):</strong> ₹1,999</li>
        <li><strong>Fill/Refill:</strong> ₹999</li>
        <li><strong>Acrylic Removal:</strong> ₹399</li>
        <li><strong>Nail Repair:</strong> ₹199 per nail</li>
        <li><strong>Acrylic + Nail Art:</strong> ₹2,499+</li>
      </ul>
      
      <h2>Pros of Acrylic Nails</h2>
      <ul>
        <li>Extremely durable</li>
        <li>Easy to maintain</li>
        <li>Can achieve any length</li>
        <li>Affordable</li>
        <li>Easy repairs</li>
      </ul>
      
      <h2>Cons of Acrylic Nails</h2>
      <ul>
        <li>Can damage natural nails if not applied properly</li>
        <li>Strong odor during application</li>
        <li>Less natural looking than gel</li>
      </ul>
      
      <h2>Maintenance Tips</h2>
      <ul>
        <li>Get fills every 2-3 weeks</li>
        <li>Keep nails dry</li>
        <li>Use cuticle oil daily</li>
        <li>Avoid harsh chemicals</li>
      </ul>
      
      <h2>Get Acrylic Nails at BLR Nail Club</h2>
      <p>Our skilled technicians ensure safe, beautiful acrylic applications. Book at RR Nagar, Basaveshwarnagar, or Varthur!</p>
    `
  },
  {
    id: 28,
    slug: 'hair-smoothening-bangalore-price-guide',
    title: 'Hair Smoothening in Bangalore: Prices, Types & Best Salons 2026',
    excerpt: 'Complete guide to hair smoothening in Bangalore. Compare keratin treatment, rebonding, hair botox prices. Find the best salon for smooth, frizz-free hair.',
    category: 'Hair',
    image: 'https://images.pexels.com/photos/3993449/pexels-photo-3993449.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-05-20',
    readTime: '9 min read',
    content: `
      <p>Bangalore's humid weather can wreak havoc on your hair. <strong>Hair smoothening</strong> is the perfect solution for frizz-free, manageable hair. Here's your complete guide.</p>
      
      <h2>Types of Hair Smoothening Treatments</h2>
      
      <h3>1. Keratin Treatment</h3>
      <p>Infuses keratin protein into hair. Lasts 3-5 months.</p>
      <p><strong>Price at BLR Nail Club:</strong> ₹4,999 - ₹8,999 (based on hair length)</p>
      <p><strong>Best for:</strong> Frizzy, wavy hair</p>
      
      <h3>2. Smoothening</h3>
      <p>Semi-permanent straightening. Lasts 4-6 months.</p>
      <p><strong>Price at BLR Nail Club:</strong> ₹2,999 - ₹5,999</p>
      <p><strong>Best for:</strong> Mild frizz, wavy hair</p>
      
      <h3>3. Rebonding</h3>
      <p>Permanent straightening. Lasts until new growth.</p>
      <p><strong>Price at BLR Nail Club:</strong> ₹4,499 - ₹8,999</p>
      <p><strong>Best for:</strong> Very curly hair</p>
      
      <h3>4. Hair Botox</h3>
      <p>Deep conditioning treatment. Lasts 2-4 months.</p>
      <p><strong>Price at BLR Nail Club:</strong> ₹3,999 - ₹6,999</p>
      <p><strong>Best for:</strong> Damaged, dry hair</p>
      
      <h3>5. Nanoplastia</h3>
      <p>Chemical-free smoothening. Lasts 4-5 months.</p>
      <p><strong>Price at BLR Nail Club:</strong> ₹5,999 - ₹9,999</p>
      <p><strong>Best for:</strong> Those avoiding chemicals</p>
      
      <h2>Which Treatment is Right for You?</h2>
      <ul>
        <li><strong>Mild frizz:</strong> Keratin or Hair Botox</li>
        <li><strong>Wavy to curly:</strong> Smoothening</li>
        <li><strong>Very curly:</strong> Rebonding</li>
        <li><strong>Damaged hair:</strong> Hair Botox or Nanoplastia</li>
      </ul>
      
      <h2>Aftercare Tips</h2>
      <ul>
        <li>Wait 72 hours before washing</li>
        <li>Use sulfate-free shampoo</li>
        <li>Avoid tying hair tightly</li>
        <li>Sleep on silk pillowcase</li>
      </ul>
      
      <h2>Book Your Consultation</h2>
      <p>Visit BLR Nail Club for a personalized hair consultation. Our experts will recommend the best treatment for your hair type!</p>
    `
  },
  {
    id: 29,
    slug: 'pedicure-near-me-bangalore-guide',
    title: 'Pedicure Near Me in Bangalore: Best Foot Care Salons & Prices',
    excerpt: 'Find the best pedicure near you in Bangalore. Compare spa pedicure, medical pedicure, and luxury foot care services with prices at top salons.',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997386/pexels-photo-3997386.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-05-18',
    readTime: '6 min read',
    content: `
      <p>Searching for <strong>"pedicure near me"</strong> in Bangalore? Proper foot care is essential, especially in a city where we're always on our feet. Here's your guide to the best pedicure services.</p>
      
      <h2>Types of Pedicure Services</h2>
      
      <h3>Classic Pedicure - ₹599</h3>
      <p>Basic foot care with nail trimming, shaping, cuticle care, and polish.</p>
      <p><strong>Duration:</strong> 45 minutes</p>
      
      <h3>Spa Pedicure - ₹799</h3>
      <p>Includes scrub, mask, extended massage, and callus treatment.</p>
      <p><strong>Duration:</strong> 60 minutes</p>
      
      <h3>Luxury Pedicure - ₹999</h3>
      <p>Premium service with paraffin wax, hot stone massage, and aromatherapy.</p>
      <p><strong>Duration:</strong> 75 minutes</p>
      
      <h3>Medical Pedicure - ₹1,299</h3>
      <p>Addresses specific concerns like ingrown nails, calluses, cracked heels.</p>
      <p><strong>Duration:</strong> 60 minutes</p>
      
      <h3>Gel Pedicure - ₹1,099</h3>
      <p>Spa pedicure with long-lasting gel polish.</p>
      <p><strong>Duration:</strong> 75 minutes</p>
      
      <h2>Benefits of Regular Pedicures</h2>
      <ul>
        <li>Prevents nail diseases and infections</li>
        <li>Removes dead skin and calluses</li>
        <li>Improves blood circulation</li>
        <li>Relieves stress and tension</li>
        <li>Keeps feet soft and smooth</li>
      </ul>
      
      <h2>BLR Nail Club Pedicure Locations</h2>
      <ul>
        <li><strong>RR Nagar:</strong> N2VK Arcade - ₹599 onwards</li>
        <li><strong>Basaveshwarnagar:</strong> West of Chord Road - ₹599 onwards</li>
        <li><strong>Varthur:</strong> CSK Mall Gunjur - ₹599 onwards</li>
      </ul>
      
      <h2>Book Your Pedicure</h2>
      <p>Treat your feet to a relaxing pedicure at BLR Nail Club. Walk-ins welcome!</p>
    `
  },
  {
    id: 30,
    slug: 'nail-salon-gunjur-csk-mall',
    title: 'Nail Salon in Gunjur at CSK Mall: Complete Service Guide',
    excerpt: 'Visit BLR Nail Club at CSK Mall Gunjur for the best nail services in East Bangalore. Nail extensions, gel nails, nail art, and more. Open till 9 PM!',
    category: 'Nails',
    image: 'https://images.pexels.com/photos/3997379/pexels-photo-3997379.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: '2026-05-15',
    readTime: '5 min read',
    content: `
      <p><strong>BLR Nail Club at CSK Mall Gunjur</strong> is your neighborhood nail destination in East Bangalore. Here's everything you need to know about our Gunjur location.</p>
      
      <h2>Location Details</h2>
      <ul>
        <li><strong>Address:</strong> CSK Mall, Gunjur Main Road</li>
        <li><strong>Timings:</strong> 10 AM - 9 PM (Extended hours!)</li>
        <li><strong>Parking:</strong> Mall parking available</li>
        <li><strong>Contact:</strong> +91 7204602211</li>
      </ul>
      
      <h2>Services Available</h2>
      <ul>
        <li>Gel Nail Extensions - ₹1,499</li>
        <li>Acrylic Nails - ₹1,999</li>
        <li>Manicure & Pedicure - ₹599 onwards</li>
        <li>Nail Art - ₹100 per nail</li>
        <li>Lash Extensions - ₹2,499</li>
        <li>Nail Repair - ₹199</li>
      </ul>
      
      <h2>Areas We Serve from Gunjur</h2>
      <ul>
        <li>Gunjur</li>
        <li>Varthur</li>
        <li>Kadugodi</li>
        <li>Whitefield</li>
        <li>Hoodi</li>
        <li>Immadihalli</li>
        <li>Sarjapur Road</li>
      </ul>
      
      <h2>Why Choose CSK Mall Location?</h2>
      <ul>
        <li><strong>Convenient:</strong> Shop while you wait</li>
        <li><strong>Family-friendly:</strong> Kids services available</li>
        <li><strong>Extended hours:</strong> Open till 9 PM</li>
        <li><strong>Birthday specials:</strong> Discounts on your special day</li>
      </ul>
      
      <h2>Special Offers</h2>
      <ul>
        <li>Loyalty program - Earn points on every visit</li>
        <li>Referral bonus - ₹200 off for both</li>
        <li>Student discount - 10% off with valid ID</li>
      </ul>
      
      <h2>Book Now</h2>
      <p>Visit BLR Nail Club at CSK Mall Gunjur. Walk-ins welcome, appointments preferred!</p>
    `
  }
];

const categories = ['All', 'Nails', 'Hair', 'Skin', 'Beauty'];

const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  const filteredPosts = blogPosts.filter(post => {
    const matchesCategory = selectedCategory === 'All' || post.category === selectedCategory;
    const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <main className="bg-black min-h-screen" data-testid="blog-page">
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-black">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <h1 className="text-4xl md:text-5xl font-light text-white mb-4">
            Beauty <span className="text-[#B8860B]">Blog</span>
          </h1>
          <p className="text-white/60 text-lg font-light max-w-2xl">
            Expert tips, trends, and insights on nails, hair, skin, and beauty from BLR Nail Club
          </p>
        </div>
      </section>

      {/* Search and Filter */}
      <section className="pb-8 bg-black">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          {/* Search Bar */}
          <div className="relative mb-8">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" size={20} />
            <input
              type="text"
              placeholder="Search articles..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full bg-white/5 border border-white/10 rounded-lg pl-12 pr-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-[#B8860B] transition-colors"
            />
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 text-sm tracking-wider transition-all duration-300 ${
                  selectedCategory === category
                    ? 'bg-[#B8860B] text-black'
                    : 'bg-white/5 text-white/70 hover:bg-white/10'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="pb-24 bg-black">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.map((post) => (
              <Link
                key={post.id}
                to={`/blog/${post.slug}`}
                className="group bg-white/5 rounded-lg overflow-hidden hover:bg-white/10 transition-all duration-300"
                data-testid={`blog-card-${post.id}`}
              >
                {/* Image */}
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>

                {/* Content */}
                <div className="p-6">
                  {/* Category & Date */}
                  <div className="flex items-center gap-4 mb-3">
                    <span className="text-[#B8860B] text-xs tracking-wider uppercase">
                      {post.category}
                    </span>
                    <span className="text-white/40 text-xs flex items-center gap-1">
                      <Calendar size={12} />
                      {new Date(post.date).toLocaleDateString('en-IN', { 
                        day: 'numeric', 
                        month: 'short', 
                        year: 'numeric' 
                      })}
                    </span>
                  </div>

                  {/* Title */}
                  <h3 className="text-white text-lg font-light mb-3 group-hover:text-[#B8860B] transition-colors line-clamp-2">
                    {post.title}
                  </h3>

                  {/* Excerpt */}
                  <p className="text-white/50 text-sm font-light leading-relaxed line-clamp-3 mb-4">
                    {post.excerpt}
                  </p>

                  {/* Read More */}
                  <div className="flex items-center justify-between">
                    <span className="text-white/40 text-xs flex items-center gap-1">
                      <Clock size={12} />
                      {post.readTime}
                    </span>
                    <span className="text-[#B8860B] text-sm flex items-center gap-1 group-hover:gap-2 transition-all">
                      Read More <ArrowRight size={14} />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* No Results */}
          {filteredPosts.length === 0 && (
            <div className="text-center py-16">
              <p className="text-white/50 text-lg">No articles found matching your criteria.</p>
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export { blogPosts };
export default BlogPage;
